import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(collection: any[], sortTerms: any, sortDirection?: any): any[] {
    if (!collection) return new Array<any>();

    if (!sortTerms) return collection;

    return _.orderBy(collection, sortTerms, sortDirection);
  }
}
